import BaseCheckBox from "Engine/base/ui/BaseCheckBox";

export default class BaseMobileCheckBox extends BaseCheckBox {
    constructor(data, displayData) {
        super(data, displayData);

        this.tween = null;

        this.createTweens();
    }

    createTweens() {
        this.tween = TweenMax.to(this.scale, 0.1, {x: '-=' + 0.1, y: '-=' + 0.1, ease:Linear.easeNone, yoyo:true, repeat:1, paused:true});
    }

    get checked() {
        return this._checked;
    }

    set checked(value) {
        this._checked = value;
        this.goToFrame(this.checked ? 2 : 1);
        this.tween.pause();
        this.tween.play(0);
    }
}